import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './assets/css/DocumentDocTypeModal.css';
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";  // Biblioteca de carregamento

const DocumentDocTypeModal = ({ show, onHide, onSave, initialData }) => {
    const [loading, setLoading] = useState(false); // Estado de carregamento

    const [typeDoc, setTypeDoc] = useState({
        name: '',
        type_file: '',
        visible_file: false,
        required_file: false,
        visible_value: false,
        required_value: false,
        visible_state: false,
        required_state: false,
        visible_type_of_person: false,
        required_type_of_person: false
    });

    useEffect(() => {
        if (initialData) {
            setTypeDoc(initialData);
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { id, type, checked, value } = e.target;
        setTypeDoc(prevState => ({
            ...prevState,
            [id]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSave = (e) => {
        e.preventDefault();
        setLoading(true); // Ativar carregamento

        ApiService.send('post', `${process.env.REACT_APP_URL_API}documents/type-docs`, typeDoc, true)
            .then((res) => {
                if ( res.code == 201) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text:  'Documento salvo com sucesso.',
                    });
                    onHide(); // Chama a função de callback passando o documento salvo
                } else {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Aviso!',
                        text: res.data.message || 'Ocorreu um problema ao salvar o documento.',
                    });
                }
            })
            .catch((error) => {
                console.error("Erro na API:", error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response?.data?.message || 'Ocorreu um erro ao salvar o documento.',
                });
            })
            .finally(() => {
                setLoading(false); // Desativar carregamento
            });
    };

    return (
        <>
            {loading && <LoadingScreen />}  {/* Exibe o carregamento enquanto `loading` for true */}
            {show && <div className="modal-backdrop fade show"></div>}
            <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="100" aria-labelledby="documentDocTypeModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="documentDocTypeModalLabel">Cadastro de Documento</h5>
                            <button type="button" className="btn-close"  onClick={() =>onHide()} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSave}>
                                {/* Nome do Documento */}
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Nome do Documento</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        value={typeDoc.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Visível */}
                                <div className="painel mb-3">
                                    <div className="mb-3">
                                        <label className="form-label">Anexo</label>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="visible_file"
                                                checked={typeDoc.visible_file}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="visible_file">
                                                Marcar se tem anexo
                                            </label>
                                        </div>
                                    </div>

                                    {/* Obrigatório */}
                                    {typeDoc.visible_file && (
                                        <div className="mb-3">
                                            <label className="form-label">Anexo é Obrigatório</label>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="required_file"
                                                    checked={typeDoc.required_file}
                                                    onChange={handleChange}
                                                />
                                                <label className="form-check-label" htmlFor="required_file">
                                                    Marcar se o Anexo deve ser obrigatório
                                                </label>
                                            </div>
                                        </div>
                                    )}

                                    {/* Tipo de Arquivo */}
                                    {typeDoc.visible_file && (
                                        <div className="mb-3">
                                            <label htmlFor="type_file" className="form-label">Tipo de Anexo</label>
                                            <select
                                                className="form-control"
                                                id="type_file"
                                                value={typeDoc.type_file}
                                                onChange={handleChange}
                                                menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                                styles={{
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    }), // Definindo z-index alto
                                                    menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                                }}
                                            >
                                                <option value="" disabled>Selecionar</option>
                                                <option value="image">Imagem</option>
                                                <option value="file">Arquivo</option>
                                            </select>
                                        </div>
                                    )}
                                </div>

                                {/* Valor Visível */}
                                <div className="painel mb-3">
                                    <div className="mb-3">
                                        <label className="form-label">Texto ou numérico</label>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="visible_value"
                                                checked={typeDoc.visible_value}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="visible_value">
                                                Marcar se o valor deve ser visível
                                            </label>
                                        </div>
                                    </div>

                                    {typeDoc.visible_value && (
                                        <div className="mb-3">
                                            <label className="form-label">Valor Obrigatório</label>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="required_value"
                                                    checked={typeDoc.required_value}
                                                    onChange={handleChange}
                                                />
                                                <label className="form-check-label" htmlFor="required_value">
                                                    Marcar se o valor deve ser obrigatório
                                                </label>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Estado Visível */}
                                <div className="painel mb-3">
                                    <div className="mb-3">
                                        <label className="form-label">Estado (SP/MG/RJ)</label>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="visible_state"
                                                checked={typeDoc.visible_state}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="visible_state">
                                                Marcar se o estado deve ser visível
                                            </label>
                                        </div>
                                    </div>

                                    {typeDoc.visible_state && (
                                        <div className="mb-3">
                                            <label className="form-label">Estado Obrigatório</label>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="required_state"
                                                    checked={typeDoc.required_state}
                                                    onChange={handleChange}
                                                />
                                                <label className="form-check-label" htmlFor="required_state">
                                                    Marcar se o estado deve ser obrigatório
                                                </label>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Tipo de Pessoa Visível */}
                                <div className="painel mb-3">
                                    <div className="mb-3">
                                        <label className="form-label">Tipo de Pessoa Visível (Física ou Jurídica)</label>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="visible_type_of_person"
                                                checked={typeDoc.visible_type_of_person}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="visible_type_of_person">
                                                Marcar se o tipo de pessoa deve ser visível
                                            </label>
                                        </div>
                                    </div>

                                    {typeDoc.visible_type_of_person && (
                                        <div className="mb-3">
                                            <label className="form-label">Tipo de Pessoa Obrigatório</label>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="required_type_of_person"
                                                    checked={typeDoc.required_type_of_person}
                                                    onChange={handleChange}
                                                />
                                                <label className="form-check-label" htmlFor="required_type_of_person">
                                                    Marcar se o tipo de pessoa deve ser obrigatório
                                                </label>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() =>onHide()}>Cancelar</button>
                                    <button type="submit" className="btn btn-primary">Salvar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DocumentDocTypeModal;
